import { io } from 'socket.io-client';

export default function setupWebSocket(userId) {
  if (!userId) {
    // console.warn('🔌 Usuário não autenticado, WebSocket não será iniciado.');
    return;
  }

  const socket = io('https://ws.dashsuite.com.br', {
    transports: ['websocket'],
  });

  socket.on('connect', () => {
    // console.log('🟢 Conectado ao WebSocket');
    // console.log('🧩 Enviando userId para socket:', userId, typeof userId);
    socket.emit('register', String(userId).trim());
  });

  socket.on('forceDisconnect', () => {
    // console.warn('🔌 Você foi desconectado por login em outro dispositivo.');
    alert('Sua conta foi acessada em outro dispositivo. Você será desconectado.');

    // Cria e envia um formulário POST para fazer logout corretamente
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = '/logout';

    // Token CSRF
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
    if (csrfToken) {
      const tokenInput = document.createElement('input');
      tokenInput.type = 'hidden';
      tokenInput.name = '_token';
      tokenInput.value = csrfToken;
      form.appendChild(tokenInput);
    }

    document.body.appendChild(form);
    form.submit();
  });

  socket.on('disconnect', () => {
    // console.log('🔴 Desconectado do WebSocket');
  });
}
